import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AndroidDownload from "@/components/AndroidDownload";

export function Header({ title }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const bal = user && typeof user === "object" ? user.balance : 0;
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B0E14]/80 border-b border-[#1E293B]">
      <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
        <span className="font-display text-lg font-bold tracking-tight">{title}</span>
        <div className="flex items-center gap-2">
        <AndroidDownload compact />
        <button
          data-testid="header-balance-pill"
          onClick={() => navigate("/wallet")}
          className="flex items-center gap-2 pl-3 pr-1.5 py-1.5 rounded-full bg-[#121721] border border-[#1E293B]"
        >
          <span className="font-mono-num text-sm font-semibold text-[#00E676]">
            {Number(bal || 0).toFixed(2)}
          </span>
          <span className="text-[10px] text-slate-500 font-mono-num">USDT</span>
          <span className="w-6 h-6 rounded-full bg-[#00E676] flex items-center justify-center">
            <Plus size={14} className="text-black" strokeWidth={3} />
          </span>
        </button>
        </div>
      </div>
    </header>
  );
}
